import script from "./ImageWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageWrapper.vue?vue&type=script&setup=true&lang=js"

import "./ImageWrapper.vue?vue&type=style&index=0&id=449bc2b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-449bc2b7"]])

export default __exports__